import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Set the mechanism for dismissing Universal Checkout. Options are:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`gestures`}</inlineCode>{`: The dialog can be dismissed by tapping outside or by swiping down.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`closeButton`}</inlineCode>{`: A close button is provided, allowing users to dismiss the dialog manually.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      